import { lsPut, safeAwait } from 'utils/request'

export const setVenderViewedOrClicked = (venderId, params) => {
  return safeAwait(lsPut(`/venders/${venderId}/clicksOrViews`, params))
}
